import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }

import {ref} from "vue";
import store from "@/store";
import {useApi} from "@/api/handler";
import {user} from "@/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterBox',
  emits: ['pushBack'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const codeSent = ref<boolean>(false)
const countDown = ref<number>(60)
let counter: ReturnType<typeof setInterval> | null = null

const email = ref<string>('')
const code = ref<string>('')
const password = ref<string>('')
const rePassword = ref<string>('')

const passwordVisible = ref<boolean>(false)
const rePasswordVisible = ref<boolean>(false)

function handleSendEmail(): void {
  if (codeSent.value) return
  if (email.value === '') {
    store.dispatch('snackBarModule/showError', '请正确填写邮箱')
    return
  }
  codeSent.value = true
  counter = setInterval(() => {
    countDown.value -= 1
    if (countDown.value === 0) {
      countDown.value = 60
      codeSent.value = false
      if (counter) clearInterval(counter)
    }
  }, 1000)
  useSendEmail()
}

function handleRegister(): void {
  if (password.value !== rePassword.value) {
    store.dispatch('snackBarModule/showError', '两次密码输入不一致')
    return
  }
  if (password.value.length < 6 || password.value.length > 20) {
    store.dispatch('snackBarModule/showError', '密码长度应介于6与20之间')
    return
  }
  useRegister()
}

const useSendEmail = () => {
  useApi({api: user.SendEmail(email.value), tip: '发送成功'})
}

const useRegister = () => {
  useApi({
    api: user.Register({
      username: email.value,
      email: email.value,
      password: password.value,
      nickname: email.value,
      avatar: '',
      type: 0,
      code: code.value
    }),
    onSuccess: () => {
      setTimeout(() => {
        emits('pushBack')
      }, 1000)
    },
    tip: '注册成功'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_text_field, {
      density: "compact",
      placeholder: "请输入邮箱",
      "prepend-inner-icon": "mdi-email-outline",
      variant: "outlined",
      prefix: "   ",
      rounded: "",
      modelValue: email.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_text_field, {
        density: "compact",
        placeholder: "请输入验证码",
        prefix: "   ",
        variant: "outlined",
        rounded: "",
        modelValue: code.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((code).value = $event)),
        "prepend-inner-icon": "mdi-security"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_btn, {
        class: "ml-4 code-button",
        color: "primary",
        disabled: codeSent.value,
        onClick: handleSendEmail
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(codeSent.value ? countDown.value + '秒后重试' : '获取验证码'), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_v_text_field, {
      "append-inner-icon": passwordVisible.value ? 'mdi-eye-off' : 'mdi-eye',
      density: "compact",
      placeholder: "请输入密码",
      prefix: "   ",
      variant: "outlined",
      rounded: "",
      modelValue: password.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
      "prepend-inner-icon": "mdi-lock-outline",
      type: passwordVisible.value ? 'text' : 'password',
      "onClick:appendInner": _cache[3] || (_cache[3] = ($event: any) => (passwordVisible.value = !passwordVisible.value))
    }, null, 8, ["append-inner-icon", "modelValue", "type"]),
    _createVNode(_component_v_text_field, {
      "append-inner-icon": rePasswordVisible.value ? 'mdi-eye-off' : 'mdi-eye',
      density: "compact",
      placeholder: "请再次输入密码",
      prefix: "   ",
      variant: "outlined",
      rounded: "",
      modelValue: rePassword.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rePassword).value = $event)),
      "prepend-inner-icon": "mdi-lock-outline",
      type: rePasswordVisible.value ? 'text' : 'password',
      "onClick:appendInner": _cache[5] || (_cache[5] = ($event: any) => (rePasswordVisible.value = !rePasswordVisible.value))
    }, null, 8, ["append-inner-icon", "modelValue", "type"]),
    _createVNode(_component_v_btn, {
      block: "",
      rounded: "",
      color: "blue-lighten-1",
      class: "mt-4",
      size: "large",
      onClick: handleRegister
    }, {
      default: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("注册")
      ])),
      _: 1,
      __: [6]
    })
  ], 64))
}
}

})